import Primary from 'components/Button/Primary';
import PrimaryWithLoader from 'components/Button/PrimaryWithLoader';
import Secondary from 'components/Button/Secondary';
import Tertiary from 'components/Button/Tertiary';
import Back from 'components/Button/Back';
import StyleReset from 'components/Button/StyleReset';
import Underlined from 'components/Button/Underlined';

export {
  Primary,
  PrimaryWithLoader,
  Secondary,
  Tertiary,
  Back,
  StyleReset,
  Underlined,
};

const button = {
  Primary,
  PrimaryWithLoader,
  Secondary,
  Tertiary,
  Back,
  StyleReset,
  Underlined,
};

export default button;
